import IShopInfo from '../models/IShopInfo'

const getAddressFromShopInfo = (shopInfo: IShopInfo, withPostalCode?: boolean): string => {
  let addressString = ''
  const keys: (keyof IShopInfo)[] = ['address', 'city', 'state']
  if (withPostalCode) {
    keys.push('postalCode')
  }

  keys.forEach(key => {
    if (!shopInfo[key]) {
      return
    }
    if (addressString) {
      if (key === 'postalCode') {
        addressString += ' '
      } else {
        addressString += ', '
      }
    }
    addressString += shopInfo[key]
  })

  return addressString
}

export default getAddressFromShopInfo
